<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.GAS_WARNING_CENTER">
  </app-configuration-wizard-back-button>
  <odx-wizard
    class="odx-gaswarn-center-wizard"
    #configurationWizard
    [vertical]="true"
    (activeStepChanged)="updateActiveStep($event)"
  >
    <odx-wizard-step i18n="@@gasWarningCenterConfiguration.wizard.step1">Serie</odx-wizard-step>
    @for (step of selectedSteps; track $index) {
      <odx-wizard-step>{{ step.title }}</odx-wizard-step>
    }
  </odx-wizard>

  <app-gas-warning-center-type-selector
    class="w-100 h-100"
    [hidden]="activeStep !== 0"
    [selectedType]="originalConfiguration?.gasWarningCenter?.getLocalizedName('de-DE')"
    (typeSelected)="setSelectedType($event)"
    (formReady)="selectedGasWarningCenterTypeForm = $event"
  ></app-gas-warning-center-type-selector>
  @if (selectedType?.key === "Regard_3000" || selectedType?.key === "Regard_3000_plus") {
    <app-gas-warning-center-module-selector
      class="w-100 h-100"
      [originalRegard3000Configuration]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard3000Configuration : undefined
      "
      (selectedInputModulesChange)="selectRegard3000InputModules($event)"
      (selectedRelayModulesChange)="selectRegard3000RelayModules($event)"
      (selectedGatewayModulesChange)="selectRegard3000GatewayModules($event)"
      [hidden]="activeStep !== 1"
      [type]="selectedType"
      [showCosts]="project.showCostFlag"
    ></app-gas-warning-center-module-selector>
    <app-base-unit-selector
      class="w-100 h-100"
      [type]="selectedType"
      [originalBaseUnits]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard3000Configuration?.baseUnits : undefined
      "
      [selectedInputModules]="regard3000SelectionState.selectedInputModules"
      [selectedRelayModules]="regard3000SelectionState.selectedRelayModules"
      [selectedGatewayModules]="regard3000SelectionState.selectedGatewayModules"
      (selectedBaseUnitsChange)="selectRegard3000BaseUnits($event)"
      (slotCoversChange)="updateRegard3000SlotCovers($event)"
      (isBaseUnitSelectionValid)="isBaseUnitSelectionValid = $event"
      [hidden]="activeStep !== 2"
      [showCosts]="project.showCostFlag"
    ></app-base-unit-selector>
    <app-lid-unit-selector
      class="w-100 h-100"
      [originalLidUnits]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard3000Configuration?.lidUnits : undefined
      "
      [hidden]="activeStep !== 3"
      [type]="selectedType"
      [selectedBaseUnits]="regard3000SelectionState.selectedBaseUnits"
      [showCosts]="project.showCostFlag"
      (isLidSelectionValid)="isLidSelectionValid = $event"
      (selectedLidUnitsChange)="selectRegard3000LidUnits($event)"
    >
    </app-lid-unit-selector>

    <app-attachment-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 4"
      [headerProducts]="regard3000SelectionState.selectedBaseUnitProducts"
      [products]="
        shouldRestoreOriginalConfiguration && originalConfiguration?.regard3000Configuration?.baseUnits
          ? {
              selectedProducts: regard3000SelectionState.selectedBaseUnitProducts,
              preselectedAttachments: originalConfiguration!.attachments,
            }
          : { selectedProducts: regard3000SelectionState.selectedBaseUnitProducts }
      "
      [showCosts]="project.showCostFlag"
      [excludedFullTypes]="[
        FullProductType.REGARD_3000_INPUT_ANALOG,
        FullProductType.REGARD_3000_RELAIS,
        FullProductType.REGARD_3000_GATEWAY,
        FullProductType.REGARD_3000_DB,
        FullProductType.ATTACHMENT_OPTIONAL_SLOTCOVER,
      ]"
      (attachmentsSelect$)="selectedAttachments = $event"
    >
    </app-attachment-selector>
  } @else if (selectedType?.key === "Regard_7000") {
    <app-gas-warning-center-module-selector-regard-7000
      class="w-100 h-100"
      [originalConfiguration]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard7000PlusConfiguration : undefined
      "
      (moduleSelectionChanged)="selectRegard7000Modules($event)"
      [hidden]="activeStep !== 1"
      [project]="project"
    ></app-gas-warning-center-module-selector-regard-7000>
    <app-terminal-blocks-selector
      class="w-100 h-100"
      [project]="project"
      [hidden]="activeStep !== 2"
      [originalTerminalBlocks]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard7000PlusConfiguration?.terminalBlocks : undefined
      "
      [selectedModules]="selectedRegard7000Modules()"
      (terminalBlocksSelect$)="selectedTerminalBlocksRegard7000.set($event)"
    ></app-terminal-blocks-selector>
    <app-docking-station-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 3"
      [project]="project"
      [type]="selectedType!"
      [originalDockingStations]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard7000PlusConfiguration?.dockingStations : undefined
      "
      [selectedModules]="selectedRegard7000Modules()"
      (dockingStationsSelect$)="selectRegard7000DockingStations($event)"
      (isSelectionValid$)="isDockingStationSelectionValid = $event"
      (necessarySlotCovers$)="necessaryRegard7000SlotCovers.set($event)"
    ></app-docking-station-selector>
    <app-dashboard-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 4"
      [project]="project"
      [originalDashboards]="
        shouldRestoreOriginalConfiguration ? originalConfiguration?.regard7000PlusConfiguration?.dashboards : undefined
      "
      (dashboardSelect$)="selectedDashboardsRegard7000.set($event)"
    ></app-dashboard-selector>
    <app-attachment-selector-regard-7000
      class="w-100 h-100"
      [hidden]="activeStep !== 5"
      [products]="{
        selectedProducts: selectedRegard7000Products(),
        preselectedAttachments: shouldRestoreOriginalConfiguration ? originalConfiguration?.attachments : undefined,
        preselectedSlotCovers: necessaryRegard7000SlotCovers(),
      }"
      [showCosts]="project.showCostFlag"
      (attachmentsSelect$)="selectedAttachments = $event"
    >
    </app-attachment-selector-regard-7000>
  } @else {
    <app-gas-warning-center-selector
      class="w-100 h-100"
      [hidden]="activeStep !== 1"
      [project]="project"
      [type]="selectedType"
      [originalGasWarningCenter]="shouldRestoreOriginalConfiguration ? originalConfiguration?.gasWarningCenter : undefined"
      (gasWarningCenterSelect$)="selectGasWarningCenter($event)"
      (formReady)="selectedGasWarningCenterForm = $event"
    >
    </app-gas-warning-center-selector>

    @if (selectedGasWarningCenter) {
      <app-attachment-selector
        class="w-100 h-100"
        [hidden]="activeStep !== 2"
        [headerProducts]="[selectedGasWarningCenter]"
        [products]="
          shouldRestoreOriginalConfiguration && selectedGasWarningCenter.id === originalConfiguration?.gasWarningCenter?.id
            ? { selectedProducts: [selectedGasWarningCenter], preselectedAttachments: originalConfiguration!.attachments }
            : { selectedProducts: [selectedGasWarningCenter] }
        "
        [showCosts]="project.showCostFlag"
        (attachmentsSelect$)="selectedAttachments = $event"
      >
      </app-attachment-selector>
    }
  }
  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="configurationWizard.previousStep()"
    [activeStep]="activeStep"
    [steps]="steps"
  >
  </app-product-config-stepper-bar>
</div>
